// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import api from '../../../services/api';


const redeemVoucher = async (data) => {
  return api(
    '/Sellitback.svc/RedeemVoucher',
    data,
    'POST'
  );
};


export {
  redeemVoucher
};
